<template>
    <!-- <div> -->
    <!-- :id="this.$colorMode.value === 'dark' ? 'darkMap' : 'lightMap'" -->

    <div id="darkMap" class="tdf-map" />
    <!-- <b-button @click="drawMap()">test</b-button> -->
    <!-- </div> -->
</template>
<style lang="scss" scoped>
// .floating-section {
//   z-index: 100 !important;
// }

#lightMap,
#darkMap {
    mask-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 0.8) 80%,
        rgba(0, 0, 0, 0) 100%
    );
    z-index: 0;
    position: relative;
    top: 0;
    left: 0;
    width: 100vw;
    // bottom: 0;
    right: 0;
    height: 80vh;
    // overflow: none;
    // border-radius: 1.15em;
    pointer-events: none;
    // z-index: 0 !important;
    // opacity: .5;
    margin-bottom: 1em;
    @media (max-width: 960px) {
        // position: absolute;
        height: 80vh;
        border-radius: 0;
        margin: 0;
    }
}
</style>
<script>
import mapboxgl from "mapbox-gl";

export default {
    name: "Map",
    data() {
        return {
            access_token:
                process.env.MAPBOX_API_KEY ||
                "pk.eyJ1IjoiZ2RpY3IiLCJhIjoiY2t6cHI0OWR4MGVpMDMxbGc1dnZ0ZjByNSJ9.Z7YN6x3Yk82q6NVVYDfpnA",
            map: {},
            mapArgs: {
                container: "darkMap",
                // this.$colorMode.value === "dark" ? "darkMap" : "lightMap",
                style:
                    // this.$colorMode.value === "dark"
                    // ?
                    // "mapbox://styles/gdicr/ckzptm2sp000214mae50z3ebr",
                    "mapbox://styles/gdicr/clu234xxm00m001mj909l4hia",
                // : "mapbox://styles/gdicr/ckzu45wsf00nb14nyc8ica8h4",
                zoom: 15,
                center: [9.175668, 45.485655],
                antialias: true,
                pitch: 65,
                bearing: 0,
                minZoom: 15,
                maxZoom: 17,
                scrollZoom: false,
                dragRotate: false,
                dragPan: false,
                touchZoomRotate: false,
                touchPitch: false,
                doubleClickZoom: false,
                keyboard: false,
                preserveDrawingBuffer: true,
                interactive: false,
                attributionControl: false,
            },
            layerArgs: {
                id: "add-3d-buildings",
                source: "composite",
                "source-layer": "building",
                filter: ["==", "extrude", "true"],
                type: "fill-extrusion",
                minzoom: 15,
                paint: {
                    // extrude buildings based on height and color buildings based on density
                    "fill-extrusion-height": [
                        "interpolate",
                        ["linear"],
                        ["get", "height"],
                        0,
                        0,
                        12,
                        30,
                        30,
                        30,
                    ],

                    "fill-extrusion-base": 0,
                    "fill-extrusion-opacity": 0.895,
                    "fill-extrusion-color": [
                        "interpolate",
                        ["linear"],
                        ["get", "height"],
                        0,
                        "#62a7d4",
                        15,
                        "  #6b95e0",
                        30,
                        "#6e66e0",
                    ],

                    "fill-extrusion-opacity-transition": {
                        duration: 1000,
                        delay: 1000,
                    },
                },
            },
        };
    },
    mounted() {
        this.drawMap();

        // let mapArgs = ;
        // console.log(this.stream);
        // console.log(VideoPlayer.methods.onPlayerWaiting(player));
        // $(document).ready(function () {
        //           console.log();
        //   // $(".chat-container").css({
        //   //   maxHeight: $(".vjs-theme-custom").height(),
        //   // });
        // });
        // if (this.$colorMode.value == "dark") {
        //   $("#map").css("mix-blend-mode", "lighten"); // console.log(rotatingMap);
        //   $("#map").css("z-index", "0 !important"); // console.log(rotatingMap);
        // } else if (this.$colorMode.value == "light") {
        //   $("#map").css("mix-blend-mode", "multiply"); // console.log(rotatingMap);
        //   $("#map").css("z-index", "0 !important"); // console.log(rotatingMap);
        // }
    },
    beforeMount() {},
    updated() {},
    methods: {
        drawMap() {
            // this.computeMapStyle(this.$colorMode.value);
            this.createMap(this.mapArgs, this.layerArgs);
        },
        computeMapStyle(colorMode) {
            // if (colorMode === "dark") {
            return "darkMap";
            // } else {
            //     return "lightMap";
            // }
        },
        createMap(args, layerArgs) {
            mapboxgl.accessToken = this.access_token;
            mapboxgl.antialias = true;
            mapboxgl.preserveDrawingBuffer = true;

            this.map = new mapboxgl.Map(args);

            this.map.on("load", () => {
                // Insert the layer beneath any symbol layer.
                new mapboxgl.Marker({
                    color: "#6e66e0",
                    element: document.getElementById("marker"),
                    offset: [0, 0],
                    anchor: "bottom",
                    // color:
                    scale: 1.5,
                    draggable: false,
                    // clickTolerance:
                    rotation: 0,
                    // rotationAlignment: "map",
                    // pitchAlignment: "map",
                })
                    .setLngLat([9.175668, 45.485655])
                    .addTo(this.map);
                const layers = this.map.getStyle().layers;
                const labelLayerId = layers.find(
                    (layer) =>
                        layer.type === "symbol" && layer.layout["text-field"]
                ).id;

                this.map.addLayer(layerArgs, labelLayerId);
            });
            let rotatingMap = this.map;

            rotatingMap.flyTo({
                center: [9.175668, 45.485655],
                zoom: 17,
                speed: 0.5,
                curve: 1,
                easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
                essential: true, // this animation is considered essential with respect to prefers-reduced-motion
            });

            setTimeout(() => {
                function draw(now) {
                    // rotate smoothly to a bearing of 90 degrees
                    rotatingMap.setBearing(now / 500);

                    requestAnimationFrame(draw);
                }

                requestAnimationFrame(draw);

                return clearTimeout(draw, 2500);
            }, 2500);
        },

        // async getLiveroom() {
        //   const { data } = await graphql(GET_LIVEROOM, {
        //     id: { id: "5fca6a0d9f8b2126886fba30" },
        //   });
        //   this.stream = data.Liveroom;
        // },
    },
};
</script>
